'use client';

import React, { useEffect, useState } from 'react';
import Image from 'next/image';
import { Container, Divider, Group, Input, Pagination } from '@mantine/core';
import { HorizontalImageCard } from '@/src/components/SliceMachine/HorizontalImageCard/HorizontalImageCard';
import VerticalCardList from '@/src/components/SliceMachine/VerticalCardList/VerticalCardList';
import { useDictionary } from '@/src/dictionaries/dictionary-provider';
import { fetchProducts } from '@/src/helpers/fetch-products';

interface Product {
  id: string;
  title: string;
  tags: string[];
  mainImage: string;
  createdAt: string;
  dimentions: { width: number; length: number };
  price: number;
  description: string;
  content: string;
  author?: string;
  category?: string;
}

const ProductsPage = () => {
  const [products, setProducts] = useState<Product[]>([]);
  const [page, setPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');
  const [totalPages, setTotalPages] = useState(1);
  const dictionary = useDictionary();

  useEffect(() => {
    const fetchData = async () => {
      const result: any = await fetchProducts(page, searchQuery);
      setProducts(result.products);
      setTotalPages(result.totalPages);
    };
    fetchData();
  }, [page, searchQuery]);

  return (
    <Container my="md">
      {/* @ts-ignore */}
      <HorizontalImageCard data={dictionary.pages.products.headerCard} />
      <Divider />
      <Group align="center">
        <Image
          src="https://img.icons8.com/c9a456/ios-filled/50/search--v1.png"
          alt="search"
          height={20}
          width={20}
        />
        {/* @ts-ignore */}
        <p>{dictionary.pages.products.search}</p>
      </Group>
      <Input
        placeholder={dictionary.pages.products.search}
        value={searchQuery}
        onChange={(event) => setSearchQuery(event.target.value)}
        mb="lg"
      />

      {/* @ts-ignore */}
      <VerticalCardList products={products} data={dictionary.pages.products} />

      <Group mt="lg">
        <Pagination
          // @ts-ignore
          page={page}
          onChange={setPage}
          total={totalPages}
          color="black"
        />
      </Group>
    </Container>
  );
};

export default ProductsPage;
